import React, { Fragment, useEffect, useRef } from 'react'

// third party components
import { Dialog, Transition } from '@headlessui/react'
import CloseIcon from 'assets/icons/close-white-black-15x15.svg?component'

// styles
import styles from './index.module.scss'

const ImageExpandModal = props => {
  const { open, close, image } = props

  const closeModal = () => {
    close()
  }

  return (
    <div>
      <Transition show={open} as={Fragment}>
        <Dialog as="div" className={styles.container} onClose={() => closeModal()}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className={styles.bgView}></div>
          </Transition.Child>

          <div className="fixed inset-0" onClick={() => closeModal()}>
            <div className="absolute inset-0 overflow-y-auto">
              <div className="w-[1000px] lg:w-full flex h-auto py-[50px] lg:py-[30px]">
                <img src={image} className="w-full h-auto" />
              </div>
            </div>

            <div className={styles.close} onClick={() => closeModal()}>
              <CloseIcon alt="" />
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  )
}

export default ImageExpandModal
